"use client";

import * as Sentry from "@sentry/nextjs";
import { useEffect } from "react";

export default function GlobalError({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  useEffect(() => {
    Sentry.captureException(error);
  }, [error]);

  return (
    <html lang="tr">
      <body className="min-h-screen bg-slate-950 text-white">
        <main className="flex min-h-screen items-center justify-center px-6 py-12">
          <div className="w-full max-w-md space-y-5 rounded-lg border border-white/10 bg-white/10 p-6 shadow-2xl">
            <div className="space-y-2">
              <p className="text-sm font-medium uppercase tracking-wider text-sky-200">
                Sistem hatasi
              </p>
              <h1 className="text-2xl font-semibold">Beklenmeyen bir hata olustu.</h1>
              <p className="text-sm leading-6 text-slate-300">
                Hata kaydedildi. Sayfayi yeniden deneyebilir veya daha sonra tekrar
                acabilirsiniz.
              </p>
            </div>
            <button
              type="button"
              onClick={reset}
              className="inline-flex h-10 items-center justify-center rounded-md bg-sky-400 px-4 text-sm font-semibold text-slate-950 transition hover:bg-sky-300"
            >
              Yeniden dene
            </button>
          </div>
        </main>
      </body>
    </html>
  );
}
